
import React, { useState, useEffect } from "react";
import srichakra from "../Assests/namboothiri1.jpeg";
import lotus from "../Assests/namboothrichan.jpeg";
import "../Styles/About.css";

function About() {
    const [language, setLanguage] = useState("en");

    useEffect(() => {
        const updateLanguage = () => {
            const selected =
                document.querySelector(".goog-te-combo")?.value;

            const pageLanguage =
                document.documentElement.lang?.toLowerCase() || "";

            if (selected === "ta" || pageLanguage.startsWith("ta")) {
                setLanguage("ta");
            } else if (
                selected === "ml" ||
                pageLanguage.startsWith("ml")
            ) {
                setLanguage("ml");
            } else {
                setLanguage("en");
            }
        };

        document.addEventListener("change", updateLanguage);

        const observer = new MutationObserver(updateLanguage);

        observer.observe(document.documentElement, {
            attributes: true,
            attributeFilter: ["lang"],
        });

        updateLanguage();

        return () => {
            document.removeEventListener("change", updateLanguage);
            observer.disconnect();
        };
    }, []);

    const content = {
        en: {
            storyTitle: "The Story of Puliyampilly Namboothiri",
            templeTitle: "Temple History",
            referencesTitle: "References",

            story: [
                `Many centuries ago, there lived a Namboothiri named Puliyampilly Namboothiri, a great devotee of Bhadrakali Devi. He was not an ordinary priest but a powerful Tantric practitioner (Mantravadi) who spent years performing severe penance and worship. Every midnight, after everyone in the village had gone to sleep, he would enter his sacred worship room and perform secret rituals dedicated to Bhadrakali. His worship differed from the usual Vedic rituals. According to legend, he used offerings such as meat and liquor that were prescribed in certain Tantric traditions.`,

                `The other Namboothiris became suspicious. They believed he was secretly drinking alcohol and violating Brahmin customs. They decided to expose him. One night, while he was away, they entered his house and found a large covered pot. They were convinced it contained liquor. When Puliyampilly Namboothiri returned, they demanded that he open the pot. He calmly removed the lid. To everyone's surprise, the pot contained only dried areca nuts (adakka/gante). There was no trace of liquor. The visitors were embarrassed and left. After they departed, tradition says that, through Bhadrakali's grace, the contents returned to the ritual substance required for his worship, showing that the Goddess herself protected her devotee.`,

                `Although many respected him, some still doubted his spiritual powers. The local ruler challenged him to demonstrate that his powers truly came from the Goddess. Puliyampilly Namboothiri accepted the challenge. He asked the king to come outside on the night of Amavasya, when there should be no moon in the sky. After performing intense prayers to Bhadrakali, he asked the king to look upward. The king was astonished. Instead of darkness, two radiant full moons appeared in the sky. The ruler and everyone present bowed before Puliyampilly Namboothiri, recognizing him as a great Bhadrakali Upasakar. This miracle became one of the best-known legends associated with him.`,

                `The legend says that Puliyampilly Namboothiri dedicated his life to helping devotees through the blessings of Bhadrakali. His name continues to be associated with hereditary shrines where Bhadrakali and Vishnumaya are worshipped, and rituals such as Guruthi, Chenkuruthi, and Karinkuruthi are still performed according to that tradition.`,
            ],

            temple: [
                `This temple is an ancient and revered shrine located in North Paravoor, Ernakulam District, Kerala. It stands uniquely at the centre of a four-way road junction, where vehicles pass around it from all directions throughout the day. Beneath the shelter of a majestic banyan tree, the sacred shrine is enclosed by a simple four-foot-high circular cement structure.`,

                `Despite its modest appearance and its location amidst busy traffic, the temple radiates an extraordinary divine presence (Chaithanyam).`,
            ],

            highlight: [
                `It is believed that the subtle spiritual presence of Puliyampilly Namboothiri continues to reside in this banyan tree. Devotees believe that, through the grace of Sri Bhadrakali Amman, he has the power to drive away evil forces affecting a person.`,

                `For Puliyampilly, Bhadrakali was a deity who appeared to him in person. As a Shaktheya worshipper, he was called upon by people from different regions to perform exorcisms and other traditional ritual practices. It is believed that he spent a major part of his life resting beneath this banyan tree.`,

                `Elders recount that whenever he set out for worship, Goddess Bhadrakali would walk beside him in the form of a small child, gently holding his hand.`,

                `For generations, devotees have visited this sacred place with unwavering faith, believing that Goddess Bhadrakali listens to their prayers and showers them with protection, strength, and blessings.`,
            ],

            references: [
                "Aithihyamala (ഐതിഹ്യമാല) | Kottarathil Sankunni",
                "The Visva Vijnana Kosham by Sahithya Pravarthaka Co-Operative Society (SPCS), Kottayam, 1972",
                "Keralathile Sthalacharithrangal – Ernakulam Jilla by V.V.K. Valath",
            ],
        },

        ta: {
            storyTitle: "புலியம்பில்லி நம்பூதிரியின் கதை",
            templeTitle: "கோயில் வரலாறு",
            referencesTitle: "குறிப்புகள்",

            story: [
                `பல நூற்றாண்டுகளுக்கு முன்பு, பத்ரகாளி தேவியின் சிறந்த பக்தரான புலியம்பில்லி நம்பூதிரி என்ற நம்பூதிரி வாழ்ந்து வந்தார். அவர் ஒரு சாதாரண பூசாரி அல்ல, மாறாக பல ஆண்டுகள் கடுமையான தவம் மற்றும் வழிபாடுகளில் ஈடுபட்ட ஒரு சக்திவாய்ந்த தாந்திரிக சாதகர் (மந்திரவாதி). ஒவ்வொரு நள்ளிரவும், கிராமத்தில் உள்ள அனைவரும் உறங்கிய பிறகு, அவர் தனது புனிதமான வழிபாட்டு அறைக்குள் நுழைந்து பத்ரகாளிக்கு அர்ப்பணிக்கப்பட்ட இரகசிய சடங்குகளைச் செய்வார். அவரது வழிபாடு வழக்கமான வேத சடங்குகளிலிருந்து வேறுபட்டிருந்தது. புராணத்தின்படி, சில தாந்திரிக மரபுகளில் பரிந்துரைக்கப்பட்ட இறைச்சி மற்றும் மதுபானம் போன்ற காணிக்கைகளை அவர் பயன்படுத்தினார்.`,

                `மற்ற நம்பூதிரிகளுக்கு சந்தேகம் ஏற்பட்டது. அவர் இரகசியமாக மது அருந்துவதாகவும், பிராமண வழக்கங்களை மீறுவதாகவும் அவர்கள் நம்பினர். அவரை அம்பலப்படுத்த அவர்கள் முடிவு செய்தனர். ஒரு நாள் இரவு, அவர் வீட்டில் இல்லாதபோது அவர்கள் உள்ளே நுழைந்து, மூடியிருந்த ஒரு பெரிய பானையைக் கண்டனர். அதில் மதுபானம் இருப்பதாக அவர்கள் உறுதியாக நம்பினர். புலியம்பில்லி நம்பூதிரி திரும்பி வந்தபோது, பானையைத் திறக்குமாறு அவர்கள் அவரிடம் கோரினர். அவர் அமைதியாக மூடியை அகற்றினார். அனைவருக்கும் ஆச்சரியமளிக்கும் வகையில், அந்தப் பானையில் உலர்ந்த பாக்குகள் மட்டுமே இருந்தன. மதுவின் சுவடு சிறிதும் இல்லை. வந்தவர்கள் சங்கடப்பட்டு அங்கிருந்து சென்றுவிட்டனர். அவர்கள் சென்ற பிறகு, பத்ரகாளியின் அருளால், அந்தப் பானையில் இருந்தவை அவரது வழிபாட்டிற்குத் தேவையான சடங்குப் பொருளாக மீண்டும் மாறின என்றும், இது தேவியே தனது பக்தனைக் காத்தாள் என்பதைக் காட்டுகிறது என்றும் மரபு கூறுகிறது.`,

                `பலர் அவரை மதித்தாலும், சிலர் அவருடைய ஆன்மீக சக்திகள் மீது இன்னும் சந்தேகம் கொண்டிருந்தனர். உள்ளூர் ஆட்சியாளர், அவருடைய சக்திகள் உண்மையிலேயே தேவியிடமிருந்து வந்தவை என்பதை நிரூபிக்குமாறு அவருக்குச் சவால் விடுத்தார். புலியம்பில்லி நம்பூதிரி அதை ஏற்றுக்கொண்டார். வானத்தில் சந்திரன் இல்லாத அமாவாசை இரவில் வெளியே வருமாறு அவர் அரசரைக் கேட்டுக்கொண்டார். பத்ரகாளிக்குத் தீவிரமான பிரார்த்தனைகளைச் செய்த பிறகு, வானத்தை அண்ணாந்து பார்க்குமாறு அரசரைக் கேட்டுக்கொண்டார். அரசர் திகைத்துப்போனார். இருளுக்குப் பதிலாக, வானத்தில் இரண்டு ஒளிமிக்க முழு நிலவுகள் தோன்றின. ஆட்சியாளரும் அங்கிருந்த அனைவரும் புலியம்பில்லி நம்பூதிரியை ஒரு சிறந்த பத்ரகாளி உபாசகராக ஏற்றுக்கொண்டு, அவருக்கு முன்பாகத் தலைவணங்கினர். இந்த அற்புதம் அவருடன் தொடர்புடைய மிகவும் பிரபலமான புராணக்கதைகளில் ஒன்றாக மாறியது.`,

                `பத்ரகாளியின் அருளால் பக்தர்களுக்கு உதவுவதற்காக புலியம்பில்லி நம்பூதிரி தன் வாழ்நாளை அர்ப்பணித்தார் என்று ஒரு ஐதீகம் கூறுகிறது. பத்ரகாளி மற்றும் விஷ்ணுமாயா வழிபடப்படும் பரம்பரை ஆலயங்களுடன் அவரது பெயர் தொடர்ந்து தொடர்புபடுத்தப்பட்டு வருகிறது, மேலும் அந்த பாரம்பரியத்தின்படி குருதி, செங்குருதி மற்றும் கரிங்குருதி போன்ற சடங்குகள் இன்றும் செய்யப்படுகின்றன.`,
            ],

            temple: [
                `கேரள மாநிலம், எர்ணாகுளம் மாவட்டம், வடக்கு பரவூரில் அமைந்துள்ள இந்தக் கோயில், ஒரு பழமையான மற்றும் போற்றப்படும் புனிதத் தலமாகும். இக்கோயில் ஒரு நான்கு வழிச் சாலை சந்திப்பின் மையத்தில் தனித்துவமாக அமைந்துள்ளது; நாள் முழுவதும் எல்லா திசைகளிலிருந்தும் வாகனங்கள் இக்கோயிலைச் சுற்றிச் செல்கின்றன. கம்பீரமான ஆலமரம் ஒன்றின் நிழலில், இந்தப் புனிதத் தலம் நான்கு அடி உயரமுள்ள ஒரு எளிய வட்ட வடிவ சிமெண்ட் கட்டமைப்பால் சூழப்பட்டுள்ளது.`,

                `அதன் எளிமையான தோற்றத்தையும், பரபரப்பான போக்குவரத்து நெரிசலுக்கு மத்தியில் அமைந்திருப்பதையும் மீறி, இக்கோயில் ஓர் அசாதாரணமான தெய்வீகப் பிரசன்னத்தை (சைதன்யம்) வெளிப்படுத்துகிறது.`,
            ],

            highlight: [
                `இந்த ஆலமரத்தில் புளியம்பிள்ளி நம்பூதிரியின் சூட்சுமச் சாந்நித்தியம் இன்றளவும் நிலவுவதாக மக்கள் நம்புகின்றனர். மேலும், ஸ்ரீ பத்ரகாளி அம்மனின் அருளாற்றலால், ஒருவரைப் பீடித்திருக்கும் தீய சக்திகளை விரட்டும் வல்லமை அவருக்கு உண்டு என்றும் பக்தர்கள் நம்புகின்றனர்.`,

                `புலியம்பில்லிக்கு, பத்ரகாளி நேரில் தோன்றிய தெய்வமாக இருந்தார். சக்தி வழிபாட்டாளராக இருந்த புலியம்பில்லியை, பல்வேறு பகுதிகளைச் சேர்ந்த மக்கள் தீய சக்திகளை விரட்டுவதற்கும் மற்ற மாந்திரீக சடங்குகளுக்கும் இந்த ஆலமரத்தின் மேடையிலிருந்துதான் அழைத்துச் செல்வார்கள். அவர் தனது வாழ்நாளின் பெரும்பகுதியை இந்த ஆலமரத்தின் அடியில் ஓய்வெடுத்துக் கழித்ததாக நம்பப்படுகிறது.`,

                `அவர் வழிபாட்டிற்குப் புறப்படும்போதெல்லாம், பத்ரகாளி தேவி ஒரு சிறு குழந்தையைப் போல அவர் அருகில் நடந்து, மென்மையாக அவரது கையைப் பிடித்திருப்பதாகப் பெரியவர்கள் கூறுகிறார்கள்.`,

                `தலைமுறை தலைமுறையாக, பத்ரகாளி தேவி தங்கள் பிரார்த்தனைகளைக் கேட்டு, தங்களுக்குப் பாதுகாப்பையும், வலிமையையும், ஆசீர்வாதங்களையும் பொழிவதாக நம்பி, பக்தர்கள் அசைக்க முடியாத நம்பிக்கையுடன் இந்தப் புனிதத் தலத்திற்கு வருகை தருகின்றனர்.`,
            ],

            references: [
                "Aithihyamala (ஐதிஹ்யமாலா) | கொட்டாரத்தில் சங்குனி",
                "The Visva Vijnana Kosham (விஷ்வ விஞ்ஞான கோஷம்) by Sahithya Pravarthaka Co-Operative Society (SPCS)-Kottayam 1972",
                "Keralathile Sthalacharithrangal- Ernakulam Jilla (கேரளத்தின் வரலாறுகள் - எர்ணாகுளம் மாவட்டம்) by VVK VALATH",
            ],
        },
    };

    // Tamil uses the manually written Tamil content.
    // Malayalam uses English source text for Google Translate.
    const text = language === "ta" ? content.ta : content.en;

    const translationProps =
        language === "ta"
            ? { className: "notranslate", translate: "no" }
            : {};

    return (
        <div className="about-page">
            {/* SECTION 1: STORY */}
            <section className="about-section">
                <div className="container">
                    <h2 className="section-title" {...translationProps}>
                        {text.storyTitle}
                    </h2>

                    <div className="section-content clearfix">
                        <div className="float-img-left">
                            <img
                                src={lotus}
                                alt="Puliyampilly Namboothiri Achan"
                                className="about-image shadow"
                            />
                        </div>

                        {text.story.map((paragraph, index) => (
                            <p
                                key={index}
                                {...translationProps}
                                style={{ whiteSpace: "pre-line" }}
                            >
                                {paragraph}
                            </p>
                        ))}
                    </div>
                </div>
            </section>

            {/* SECTION 2: TEMPLE HISTORY */}
            <section className="goddess-section">
                <div className="container">
                    <h2 className="section-title" {...translationProps}>
                        {text.templeTitle}
                    </h2>

                    <div className="section-content clearfix">
                        <div className="float-img-right">
                            <img
                                src={srichakra}
                                alt="Bhadrakali Temple Shrine"
                                className="goddess-img shadow"
                            />
                        </div>

                        {text.temple.map((paragraph, index) => (
                            <p
                                key={index}
                                {...translationProps}
                                style={{ whiteSpace: "pre-line" }}
                            >
                                {paragraph}
                            </p>
                        ))}

                        <div
                            className={`highlight-text ${
                                language === "ta" ? "notranslate" : ""
                            }`}
                            translate={language === "ta" ? "no" : undefined}
                            style={{ whiteSpace: "pre-line" }}
                        >
                            {text.highlight.map((paragraph, index) => (
                                <p key={index}>{paragraph}</p>
                            ))}
                        </div>

                        {/* REFERENCES */}
                        <div className="references-block mt-4">
                            <p className="mb-1" {...translationProps}>
                                <strong>{text.referencesTitle}</strong>
                            </p>

                            {text.references.map((reference, index) => (
                                <p
                                    key={index}
                                    className="mb-1"
                                    {...translationProps}
                                >
                                    {reference}
                                </p>
                            ))}
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}

export default About;

